import Vue from 'vue'
import ModalWrapper from '@/components/ModalWrapper.vue'
Vue.component('ModalWrapper', ModalWrapper)
